import {
  useAssignSetting,
  useSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_BATCH_12_SIGNUP_COPY_250812 } from "@faire/retailer-settings/FE_BATCH_12_SIGNUP_COPY_250812";

export const useSettingBatch12SignUpCopy = (): boolean =>
  useSetting(FE_BATCH_12_SIGNUP_COPY_250812);

export const useAssignSettingBatch12SignUpCopy = () =>
  useAssignSetting(FE_BATCH_12_SIGNUP_COPY_250812);
